import template from './textCopy.html';

class TextCopyController {
  constructor($translate, toastWrapperService) {
    this.$translate = $translate;
    this.toastWrapperService = toastWrapperService;
  }

  $onInit() {
    if (this.label) {
      this.translatedLabel = this.$translate.instant(this.label);
    }

    if (this.copyIconTooltipText) {
      this.translatedTooltip = this.$translate.instant(this.copyIconTooltipText);
    }
    this.copyMsg = this.$translate.instant('TASK_ID_COPIED');
  }

  $postLink() {
    this.textElement = document.getElementById('textCopy');
  }

  copyText() {
    this.textElement.select();
    document.execCommand('copy');
    this.toastWrapperService.createToast(this.copyMsg, 'success');
  }
}

TextCopyController.$inject = ['$translate', 'toastWrapperService'];

const component = {
  template,
  bindings: {
    text: '<',
    label: '@',
    inputStyleClass: '@',
    copyIconTooltipText: '@'
  },
  controller: 'TextCopyController'
};

export default function (ngModule) {
  ngModule.component('textCopy', component);
  ngModule.controller('TextCopyController', TextCopyController);
}
